"use client"

import { useSnapshot } from "valtio"
import { AccountState } from "../../stores/accountStore"

export function useIsConnecting() {
  const { isConnecting } = useSnapshot(AccountState)
  return isConnecting
}
